import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getCookies } from "@/utility/helper";
import { RoutesLink } from "@/utility/RouteLinks";

const PrivateRoute: React.FC = () => {
  const location = useLocation();
  const business = import.meta.env.VITE_BUSINESS;
  const token = getCookies(business + "token");

  if (!token) {
    return (
      <Navigate
        to={{
          pathname: RoutesLink.authRoutes.login,
          search: location.search,
        }}
        replace
      />
    );
  }

  return <Outlet />;
};

export default PrivateRoute;